import React, { Component } from 'react';
// import { FiLogIn } from 'react-icons/fi';
import { Redirect } from 'react-router-dom';
import { Container } from './styles.js';
import logo from '../../assets/logo_completo_vermelho.svg';
import api from '../../services/api';
// import { FiEyeOff, FiEye } from 'react-icons/fi';
import { Spinner } from 'react-activity';
import 'react-activity/dist/react-activity.css';
import Modal from 'react-modal';
import Esqueci from './esqueci-minha-senha';
import moment from 'moment';

const customStyles = {
    overlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.2)',
      },
      content: {
        borderRadius: '8px',
        padding: '0px',
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '100%',
        maxWidth: '1130px',
        height: '100%',
        maxHeight: '800px'
      }
  };

export default class Login extends Component {

    constructor(props){
        super(props);
        this.userInput = null;
        this.passInput = null;
        this.state = {
            user: '',
            password: '',
            type: 'password',
            userClass: 'div-input',
            passClass: 'div-input',
            carregando: false,
            isOpen: false,
            redirect: 0,
        }
    }

    controllerModal(estado){
        this.setState({
            isOpen: !estado
        });
      }

    handleEye() {
        const {type} = this.state;
        if (type !== 'text') {
            this.setState({
                type: 'text'
            })
        } else {
            this.setState({
                type: 'password'
            })
        }
    }

    eventListener() {
        var user = document.getElementById("user");
        var pass = document.getElementById("pass");
        var button = document.getElementById("button");

        user.addEventListener("keyup", function(event) {
            if (event.keyCode === 13) {
                event.preventDefault();
                button.click();
            }
        })

        pass.addEventListener("keyup", function(event) {
            if (event.keyCode === 13) {
                event.preventDefault();
                button.click();
            }
        })
    }

    componentDidMount() {
        Modal.setAppElement('body');
        // const user = localStorage.getItem('@username');
        this.eventListener();
        const password = '';
        this.setState({
            // user,
            password
         })
    }

    handleInputChange(event) {
        const { name, value } = event.target;

        this.setState({...this.state, [name]: value })
    }

    async handleSubmit(event) {
        event.preventDefault()

        if (this.state.user !== '') {
            if (this.state.password.length >= 6 && this.state.password !== '') {
                this.login();
            }
        }
    };

    async login() {
        const { user, password } = this.state;
        // const history = useHistory();

         // Converter o e-mail para minúsculas
        const emailEmMinusculas = user.toLowerCase();

        this.setState({
            carregando: true
        });

        const data = { 
            // email: user,
            email: emailEmMinusculas,  
            senha: password 
        }

        try {
            await api.post('/api/login', data).then(async res => {
                if (res.data.token) {
                    this.setState({
                        carregando: false
                    });
                    localStorage.setItem("@ttl", res.data.ttl);
                    localStorage.setItem('@username', this.state.user);
                    localStorage.setItem('@jwt', res.data.token);
                    localStorage.setItem('@uf', res.data.uf);
                    localStorage.setItem('@user', JSON.stringify(res.data.user));
                    localStorage.setItem('@rest', JSON.stringify(res.data.isFuncionario));
                    if(res.data.isFuncionario) {
                        this.setState({redirect: 1});
                    } else if(res.data.isInternal) {
                        localStorage.setItem('@internal', res.data.isInternal);
                        this.setState({redirect: 2});
                    } 
                    // history.push('/home')
                    // const rid = res.data.rest.id;
                } else {
                    this.setState({
                        carregando: false
                    });
                }
            }).catch(async e => {
                await this.loginError(e.response.data);
                this.setState({
                        carregando: false
                    });
            })
        } catch (error) {
            this.setState({
                carregando: false
            });
            console.log(error.data)
        }
    }

    async loginError(input) {
        switch (input) {
            case 'A senha informada está incorreta.':
                this.setState({
                    passClass: 'div-input-error',
                    password: ''
                })
                break;
            case 'Usuário não encontrado.':
                this.setState({
                    userClass: 'div-input-error',
                })
                break;
            default:
                this.setState({
                    userClass: 'div-input-error',
                })
                break;
        }
    }

    render(){
    // redirect 1 funcionario
    // redirect 2 super usuario
    if(this.state.redirect === 1) {
        return <Redirect to='/' />
    }
    if(this.state.redirect === 2) {
        return <Redirect to='/super-user' />
    }
    return(
        <Container>
            <Modal
                isOpen={this.state.isOpen}
                // onAfterOpen={this.controllerModal(this.state.isOpen)}
                onRequestClose={() => this.controllerModal(this.state.isOpen)}
                shouldCloseOnEsc={false}
                shouldCloseOnOverlayClick={false}
                closeTimeoutMS={100}
                style={customStyles}
                contentLabel="Modal"
                >
                        <Esqueci closeModal={() => this.controllerModal(this.state.isOpen)}/>
                </Modal>
                <img 
                    alt=""
                    src={logo}
                    className="logocompletovermelho" />

                <div className="div-bem-vindo">
                    <span
                        className="sejabemvindo"
                        >Seja bem-vindo ao</span>
                        <span
                            className="paineldorestaurante"
                            >Painel do Restaurante</span>
                </div>

                    <div id="user" className={this.state.userClass}>
                            <input
                                ref={elem => (this.userInput = elem)}
                                value={this.state.user}
                                onFocus={() => {
                                    this.setState({
                                        userClass: 'div-input-focado'
                                    })
                                }}
                                onBlur={() => {
                                    this.setState({
                                        userClass: 'div-input'
                                    })
                                }}
                                onChange={e => this.setState({
                                    user: e.target.value
                                })}
                                name="userName"
                                type="text"
                                // placeholder="Digite o seu usuário"
                                required 
                                />
                            <label htmlFor="" className="label-name">
                                <span className="content-name">Digite o seu e-mail</span>
                            </label>
                    </div>

                    {this.state.userClass === 'div-input-error' ?
                    <div className="div-invalido">
                        <span
                        className='texto-invalido'
                        >Usuário inválido</span>
                    </div>    
                    : null}

                    <div id="pass" className={this.state.passClass}>
                            <input 
                                ref={elem => (this.passInput = elem)}
                                value={this.state.password}
                                onFocus={() => {
                                    this.setState({
                                        passClass: 'div-input-focado'
                                    })
                                }}
                                onBlur={() => {
                                    this.setState({
                                        passClass: 'div-input'
                                    })
                                }}
                                onChange={e => this.setState({
                                    password: e.target.value
                                })}
                                name="password"
                                type={this.state.type}
                                // placeholder="Digite sua senha"
                                required
                                />
                                <label htmlFor="" className="label-name">
                                    <span className="content-name">Digite sua senha</span>
                                </label>
                                {/* Favor NÃO ativar essa opção de mostrar a senha p/ usuário no momento do login
                                
                                    <button
                                    className="botao-olho"
                                    onClick={() => this.handleEye()}
                                    >
                                    {
                                        this.state.type === 'password'
                                        ?
                                        <FiEyeOff color="#1c0506" className="i" />
                                        :
                                        <FiEye color="#1c0506" className="i" />
                                    }
                                </button> */}
                    </div>

                    {this.state.passClass === 'div-input-error' ? 
                    <div className="div-invalido">
                        <span
                        className='texto-invalido'
                        >Senha inválida</span>
                    </div>    
                    : null}

                <div className="div-esqueci">
                    <span
                        onClick={() => this.controllerModal(this.state.isOpen)}
                        className="Esqueci-a-minha-senha"
                        >Esqueci minha senha</span>
                </div>

                <div className="div-botao">
                    <button
                        id="button"
                        onClick={() => (this.state.password.length && this.state.user.length >= 1) && this.state.userClass !== 'div-input-error'
                            ? this.login(this.state.carregando)
                            : null}
                        className={(this.state.password.length && this.state.user.length >= 1) && this.state.userClass !== 'div-input-error'
                            ? 'botaologin-active'
                            : 'botaologin'}
                        >{this.state.carregando ? <Spinner
                            className='spinner'
                            color="#fff" size={11} speed={1} animating={true} />
                        : 'Entrar no Painel do Restaurante'}</button>
                </div>
                
                <div className="div-cadastre">
                    <span
                        className="Ainda-no-parceiro-da-appedidos"
                        >Ainda não é parceiro da appedidos?</span>
                    <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://vantagens.appedidos.com.br"
                        className="Cadastre-seu-restaurante"
                        >Cadastre seu restaurante.</a>
                </div>
        </Container>
    )
    }
};